/**
 * StopCustomerViewing announces that this session has left a customer page, so other
 * agents' pills update immediately rather than after the record expires. Purely an
 * optimization on top of expiry — if it never runs the broker drops the record.
 *
 * Only this session's record is removed, so an agent with the same customer open in
 * another tab stays visible.
 */
export default class StopCustomerViewing {
  constructor(context) {
    this.context = context;
  }

  run({ customerId }) {
    // The flag is checked here rather than at each caller because this is the one
    // chokepoint they all pass through. With the feature off this session never
    // published, so clearing would retain a tombstone for a topic that never held a
    // value — and on an org whose broker has no ACL for it, spend a refused publish.
    if (!customerId || !this._isEnabled()) {
      return;
    }

    // On logout the gateway's endpoint params are cleared before this teardown
    // runs, so building the url would throw. Nothing is lost by skipping it —
    // the record expires on its own.
    if (!this.context.stores.auth.get().isLoggedIn()) {
      return;
    }

    this.context.gateways.customerViewers.stopViewing(customerId);
  }

  _isEnabled() {
    const appFeatures = this.context.stores.appFeatures.get();

    return !!appFeatures && appFeatures.isEnabled('agentsViewingCustomer');
  }
}
